import { Injectable, OnDestroy, Signal, signal, WritableSignal } from '@angular/core';
import { ApiService, ErrorResponse } from '@toteimlib/angular-lib';
import { Property } from 'app/models/property';

@Injectable({
  providedIn: 'root'
})
export class PropertyService implements OnDestroy {

  private property: WritableSignal<Property | null> = signal(null);

  private readonly storageHandler: (event: StorageEvent) => void;

  constructor(private apiService: ApiService) {
    const property: string | null = localStorage.getItem('property');

    if (property) {
      this.setProperty(JSON.parse(property));
    }

    this.storageHandler = (event: StorageEvent): void => {
      if (event.key === 'property') {
        if (!event.newValue || event.newValue === '') {
          this.removeProperty();
        }
        else if (event.newValue && event.newValue !== event.oldValue) {
          this.setProperty(JSON.parse(event.newValue));
        }
      }
    };

    window.addEventListener('storage', this.storageHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.storageHandler);
  }

  setProperty(property: Property | null): void {
    if (property) {
      property.lastupdate = property.lastupdate || Date.now();
      localStorage.setItem('property', JSON.stringify(property));
      localStorage.setItem('property_id', property.id);
      this.property.set(property);
      this.reloadProperty();
    }
    else {
      this.removeProperty();
    }
  }

  getProperty(): Signal<Property | null> {
    this.reloadProperty();

    return this.property;
  }

  reloadProperty(): void {
    if (this.property() && (Date.now() - (this.property()?.lastupdate || 0) > 60000)) {
      this.apiService.post('property', {
        property_id: this.property()?.id
      }, (res: any): void => {
        if (res.data) {
          this.setProperty(res.data);
        }
      }, (_: ErrorResponse): void => {

      });
    }
  }

  removeProperty(): void {
    localStorage.removeItem('property');
    localStorage.removeItem('property_id');
    this.property.set(null);
  }

}
